import React, {useEffect, useState} from 'react';
import styles from "./dropdown.module.css";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {getBooks} from "../../../api/requests";
import useTranslation from "next-translate/useTranslation";

const DropdownGetLevels = ({classes, defaultSelected, data, setBooks, setValidated, setSelectedType, setError, setShow, gameFirstTimeUser, setGameFirstTimeUser, mode, setGetBooksLoading, setShow2}) => {
    const [selectedItem, setSelectedItem] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';
    const toggle = () => {
        const Username = localStorage.getItem('Username');
        const token = localStorage.getItem('token');
        if (Username && token) {
            setDropdownOpen(prevState => !prevState)
        } else {
            setError(["login", false])
            setShow(true)
        }
    };
    const [firstTimeUser, setFirstTimeUser] = useState('');

    useEffect(() => {
        setFirstTimeUser(gameFirstTimeUser)
    }, [gameFirstTimeUser])

    useEffect(() => {
        setSelectedItem(isRTL ? defaultSelected.fa : defaultSelected.en)
    }, [isRTL])
    const handleSelect = (selectedItem) => {
        setGetBooksLoading(true)
        setSelectedType(selectedItem.id)
        setSelectedItem(selectedItem.title)
        setValidated(prevState => ({...prevState, level: true}))

        if (mode === 'test') {
            const gameFirstTimeUserConst = localStorage.getItem('gameFirstTimeUser');
            if (gameFirstTimeUserConst !== '4') {
                setGameFirstTimeUser(1)
                localStorage.setItem('gameFirstTimeUser', 1);
            }
        } else if (mode === 'learn') {
            const learnFirstTimeUserConst = localStorage.getItem('learnFirstTimeUser');
            if (learnFirstTimeUserConst !== '4') {
                setGameFirstTimeUser(1)
                localStorage.setItem('learnFirstTimeUser', 1);
            }
        }

        const token = localStorage.getItem('token')
        getBooks(selectedItem.id,token,isRTL).then(res => {
            if (Array.isArray(res.data)) {
                setBooks(res.data)
                setGetBooksLoading(false)
            }
        }).catch(err => {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.setItem('token', '');
                localStorage.setItem('Username', '');
                localStorage.setItem('Counter', '');
                localStorage.setItem('isLogin', '');
                localStorage.setItem('CellPhoneNum', '');
                setShow2(true);
            }
            else {
                console.log("getBooks error:", {err})
            }
        })
    };

    return (
        <div className={styles.wrapper}>
            {firstTimeUser == 0 &&
            <div className={`${styles.toolTip} ${isRTL ? '' : styles.toolTipEn}`}>
                <p className={`${styles.toolTipText} ${isRTL ? '' : styles.toolTipTextEn}`}>
                    {t('start:Start from Here!')}
                    <span
                        className={styles.toolTipSpan} >{t('start:Here you can select type of your educational game')}</span>
                </p>
            </div>
            }
            <div>
                <Dropdown className={`${styles.menuItem} ${classes.bg}`} isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        {selectedItem}
                    </DropdownToggle>
                    <DropdownMenu>
                        {data && data.map((item, index) => {
                            return <DropdownItem key={index}
                                onClick={() => handleSelect({title: item, id: index + 1})}>{item}</DropdownItem>
                        })}
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div className={classes.arrow}/>
        </div>

    );
};

export default DropdownGetLevels;